import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/icons/close-circle.svg'
import _imports_1 from '../../assets/img/logo_sportxxi_color.webp'
import _imports_2 from '../../assets/img/logo_sportxxi_blanco.webp'


const _hoisted_1 = {
  class: "setting-sidebar offcanvas offcanvas-end border-0 bg-white",
  tabindex: "-1",
  id: "settingsBar"
}
const _hoisted_2 = { class: "offcanvas-body p-0" }
const _hoisted_3 = { class: "settings-item" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LightDarkSwtichBtn = _resolveComponent("LightDarkSwtichBtn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("button", {
      type: "button",
      class: "close-btn bg-transparent position-absolute lh-1 p-0 border-0",
      "data-bs-dismiss": "offcanvas",
      "aria-label": "Close"
    }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "Image"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            src: _imports_1,
            alt: "Image",
            class: "logo-light"
          }, null, -1),
          _createElementVNode("img", {
            src: _imports_2,
            alt: "Image",
            class: "logo-dark"
          }, null, -1)
        ])),
        _: 1,
        __: [0]
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "fs-14 fw-medium text-title mb-0" }, "Enable Dark Mode", -1)),
          _createVNode(_component_LightDarkSwtichBtn)
        ])
      ])
    ])
  ]))
}